import { useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFetchData } from "../../helpers/api";
import { usePartner } from "../../helpers/BrandPageAPI";
import clsx from "clsx";

const IconGroup = ({ iconWhiteClass }) => {
  const searchRef = useRef();
  const navigate = useNavigate();
  const customerCodeStore = useParams();
  const customerCode = customerCodeStore?.UserCode;
  const { partnerData } = usePartner();
  const cartLogoColor = partnerData?.StoreColor;

  const { data: cartCount } = useFetchData(
    "cartItemCount",
    "/Partner/CartProductCount",
  );

  const handleClick = (e) => {
    e.currentTarget.nextSibling.classList.toggle("active");
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
    document.body.style.overflow = "hidden";
  };

  const handleSearch = () => {
    const searchValue = searchRef.current.value.trim();
    if (searchValue) {
      navigate(`/search?query=${encodeURIComponent(searchValue)}`);
    }
  };

  const onkeyHandleSearch = (e) => {
    if (e.key === "Enter") {
      const searchValue = searchRef.current.value.trim();
      navigate(`/search?query=${encodeURIComponent(searchValue)}`);
    }
  };

  return (
    <div className={clsx("header-right-wrap", iconWhiteClass)}>
      <div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={(e) => handleClick(e)}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <div className="search_form">
            <input
              type="text"
              placeholder="Search"
              name="search"
              ref={searchRef}
              onKeyDown={onkeyHandleSearch}
            />
            <button className="button-search" onClick={handleSearch} style={{ background: cartLogoColor }}>
              <i className="pe-7s-search" />
            </button>
          </div>
        </div>
      </div>
      <div className="same-style cart-wrap d-none d-lg-block">
        <Link className="icon-cart" to={`/${customerCode}/cart`}>
          <i className="pe-7s-shopbag" />
          <span className="count-style" style={{ background: cartLogoColor }} >{cartCount?.Data || 0}</span>
        </Link>
      </div>
      <div className="same-style cart-wrap d-block d-lg-none">
        <Link className="icon-cart" to={`/${customerCode}/cart`}>
          <i className="pe-7s-shopbag" />
          <span className="count-style" style={{ background: cartLogoColor }}>{cartCount?.Data || 0}</span>
        </Link>
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>
    </div >
  );
};

export default IconGroup;
